//export const apiUrl = 'http://127.0.0.1:8000/customer/';
//export const apiUrl = 'https://testcadomain.com/cdl/public/customer/';

export const apiUrl = 'https://cdl-showroom.com/backend/public/customer/';





